<div  style="height: 100%;" #edad3container class="svg-container ">
  <svg #svgContainer class="svg-content" [id]="id" width="100%" height="100%"></svg>
  <!-- <svg id="sankey" width="400" height="500"></svg> -->
</div>
